import { render, staticRenderFns } from "./CurrentUserButtonMenu.vue?vue&type=template&id=4543b714"
import script from "./CurrentUserButtonMenu.vue?vue&type=script&lang=js"
export * from "./CurrentUserButtonMenu.vue?vue&type=script&lang=js"
import style0 from "./CurrentUserButtonMenu.vue?vue&type=style&index=0&id=4543b714&prod&s=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports